<template>
  <div class="modal fade" :id="modalId">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">

        <!-- Popup header -->
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span>
            <span class="sr-only">Close</span>
          </button>
          <h4 class="modal-title" id="myModalLabel">
            Create new company
          </h4>
        </div>

        <!-- Popup content -->
        <div class="modal-body row">
          <!-- Form -->

          <!-- Company name -->
          <div
            class="form-group col-xs-12 col-sm-6"
            v-bind:class="{ 'has-error': $v.company.name.$error }"
          >
            <label>Company name</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter company name"
              v-model="company.name"
              @input="$v.company.name.$touch()"
              >
            <span class="help-block" v-if="!$v.company.name.required && $v.company.name.$error">Company name is required</span>
          </div>

          <!-- Company Address -->
          <div
            class="form-group col-xs-12 col-sm-6"
            v-bind:class="{ 'has-error': $v.company.address.$error }"
          >
            <label>Address</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter address"
              v-model="company.address"
              @input="$v.company.address.$touch()"
            >
            <span
              class="help-block"
              v-if="!$v.company.address.required && $v.company.address.$error"
            >
              Address is required
            </span>
          </div>

          <!-- Company Website -->
          <div
            class="form-group col-xs-12 col-sm-6"
            v-bind:class="{ 'has-error': $v.company.website.$error }"
          >
            <label>Website</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter ..."
              v-model="company.website"
              @input="$v.company.website.$touch()"
            >
            <span
              class="help-block"
              v-if="!$v.company.website.required && $v.company.website.$error"
            >
              Website is required
            </span>
          </div>

          <!-- Phone Number -->
          <div
            class="form-group col-xs-12 col-sm-6"
            v-bind:class="{ 'has-error': $v.company.phoneNumber.$error }"
          >
            <label>Phone Number</label>
            <input
              type="text"
              class="form-control"
              placeholder="Enter ..."
              v-model="company.phoneNumber"
              @blur="$v.company.phoneNumber.$touch()"
            >
            <span
              class="help-block"
              v-if="!$v.company.phoneNumber.required && $v.company.phoneNumber.$error"
            >
              Phone number is required
            </span>
            <span
              class="help-block"
              v-if="!$v.company.phoneNumber.numeric && $v.company.phoneNumber.$error"
            >
              Phone number must be a number
            </span>
            <span
              class="help-block"
              v-if="!$v.company.phoneNumber.minLength && $v.company.phoneNumber.$error"
            >
              Phone number must have at least 8 digits
            </span>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal" ref="closeButton">Close</button>
          <button type="button" class="btn btn-primary" @click="createCompany">Save changes</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import companyAPIs from './companyAPIs'
import { required, minLength, numeric } from 'vuelidate/lib/validators'

export default {
  name: 'CreateCompanyModal',
  props: [ 'modalId' ],
  data () {
    return {
      company: {
        name: '',
        address: '',
        website: '',
        phoneNumber: ''
      }
    }
  },
  validations: {
    company: {
      name: {
        required
      },
      address: {
        required
      },
      website: {
        required
      },
      phoneNumber: {
        required,
        numeric,
        minLength: minLength(8)
      }
    }
  },
  methods: {
    createCompany: function () {
      const { company } = this

      // Add company
      companyAPIs.createCompany(company)
        .then(response => {
          // Return the newly added data to parent component
          this.$emit('createCompany', response)

          // Dismiss modal by triggering the click event on Close button
          this.$refs.closeButton.click()
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    clearData: function () {
      this.company = {
        name: '',
        address: '',
        website: '',
        phoneNumber: ''
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// CreateCompanyModal.vue?4656a084